import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  cardGrid: {
    marginBottom: theme.spacing(2),
  },
  optionCard: {
    height: '100%',
    border: `1px solid ${theme.palette.divider}`,
    transition: 'all 0.2s ease',
    cursor: 'pointer',
  },
  optionCardActive: {
    borderColor: theme.palette.primary.main,
    boxShadow: `0 0 0 1px ${theme.palette.primary.main}`,
  },
  optionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontWeight: 600,
  },
  actions: {
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  rightActions: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  helperText: {
    color: theme.palette.text.secondary,
  },
  customFieldRow: {
    marginTop: theme.spacing(1),
  },
  customFieldRemove: {
    display: 'flex',
    alignItems: 'flex-start',
    paddingTop: theme.spacing(1),
  },
  sectionDivider: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    backgroundColor: theme.palette.action.disabled,
  },
}));
